import { SettingsIcon } from "../svgIcons/SettingsIcon";

type Props = {
  onOpen(): void;
  logo: string;
};

export const Header = ({ onOpen, logo }: Props) => {
  return (
    <>
      <div className="navbar bg-gradient-to-b dark:from-zinc-900/95 dark:to-zinc-800/95 from-zinc-200/95 to-zinc-100/95 border-b border-b-zinc-300 dark:border-b-zinc-700 fixed top-0 left-0 right-0 flex flex-row justify-between items-center">
        <ul className="px-safe-offset-3 pt-safe w-full flex flex-row justify-between items-center m-auto">
          <li className="w-6">
          </li>
          <li>
            <a href="/">
              <img src={logo} alt="" className="h-7 w-auto m-auto" />
            </a>
          </li>
          <li>
            <button
              data-umami-event="Header - Settings Modal"
              onClick={onOpen}
              className="flex flex-col justify-center items-center cursor-pointer font-buttons"
            >
              <SettingsIcon />
            </button>
          </li>
        </ul>
      </div>
    </>
  );
};
